<div class="box--close" [class]="lang.isRTL ? 'rtl--close' : ''">
  <i class="bi bi-x"></i>
</div>
